<div class="page">
  <div class="content">
    <i [ngClass]="success ? 'pp-icon-status_confirm' : 'pp-icon-error'"></i>
    <div class="title-primary">{{messageActionDone | cpLoginTranslate | async}}</div>
    <app-information-box class="error-details"
                         [border]="false"
                         [text1]="messageActionDetailsText1"
                         [text2]="messageActionDetailsText2"
                         [text3]="messageActionDetailsText3"
                         [contactInfo]="contactInfo"
                         [contactPositionIndex]="contactPositionIndex"
                         [centered]="true">
    </app-information-box>
    <app-information-box class="information-details"
                         [text1]="informationText1"
                         [text2]="informationText2"
                         [text3]="informationText3"
                         [actionTextIndex]="informationActionTextIndex"
                         [icon]="'pp-icon-info'"
                         (onAction)="informationAction()">
    </app-information-box>
  </div>
  <div class="buttons-wrapper" *ngIf="success">
    <cp-button-widget-custom class="primary-button call-to-action" captionToTranslate="LogInNow.Login.PP" (onClick)="goBackToLogin()"></cp-button-widget-custom>
  </div>
</div>
